import { Fragment } from "react";
import { Link } from "react-router-dom";
import "./css/gracias.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import Gracias from "../../images/gracias/gracias.png";
import Iframe from "react-iframe";

function InfoGracias({ datos }) {
  // Obtener modelo y cédula desde los props de react-router
  let modelo = datos?.match?.params?.modelo;
  let cedula = null;
  if (datos?.location?.search) {
    const query = new URLSearchParams(datos.location.search);
    cedula = query.get("cedula");
  }

  return (
    <Fragment>
      <Container className="d-flex justify-content-center px-0 px-md-3 py-3 py-md-5">
        <Iframe
          url="https://nomtrack.anvil.app/_/api/cv/"
          position="absolute"
          width="1"
          frameBorder="0"
          height="1"
        />
        <img src="https://seahorse.go2affise.com/success.jpg?offer_id=268652" alt="Pixel 1" title="Pixel 1" width="1" height="1" />
        <img src="https://seahorse.go2affise.com/success.jpg?offer_id=268872" alt="Pixel 2" title="Pixel 2" width="1" height="1" />
        <img src="https://seahorse.go2affise.com/success.jpg?offer_id=268871" alt="Pixel 3" title="Pixel 3" width="1" height="1" />
        <img src="https://seahorse.go2affise.com/success.jpg?offer_id=268870" alt="Pixel 4" title="Pixel 4" width="1" height="1" />
        <img src="https://seahorse.go2affise.com/success.jpg?offer_id=268869" alt="Pixel 5" title="Pixel 5" width="1" height="1" />
        <img src="https://prs.arkeero.net/trk_o?adv_sub=SUBID" alt="Pixel 6" title="Pixel 6" width="1" height="1" />
        <img src="https://inboxlabs.go2cloud.org/aff_l?offer_id=3549&adv_sub=SUB_ID" alt="Pixel 7" title="Pixel 7" width="1" height="1" />
        <img src="https://tracking.global-analitics.net/aff_l?offer_id=3549&adv_sub=SUB_ID" alt="Pixel 8" title="Pixel 8" width="1" height="1" />
        <img src="https://track.leadsinbx.com/aff_l?offer_id=3549&adv_sub=SUB_ID" alt="Pixel 9" title="Pixel 9" width="1" height="1" />
        <img src="https://inboxlabs.go2cloud.org/aff_l?offer_id=3523&adv_sub=SUB_ID" alt="Pixel 10" title="Pixel 10" width="1" height="1" />
        <img src="https://tracking.global-analitics.net/aff_l?offer_id=3523&adv_sub=SUB_ID" alt="Pixel 11" title="Pixel 11" width="1" height="1" />
        <img src="https://track.leadsinbx.com/aff_l?offer_id=3523&adv_sub=SUB_ID" alt="Pixel 12" title="Pixel 12" width="1" height="1" />
        <img src="https://px.kleup.com/tre?ev=conv&camp=72119aab-38c4-4c32-91e5-5be5e6157a94&tr={TRANSACTION_ID}" width="1" height="1" alt="Pixel 13" title="Pixel 13" />
        {/* PIXEL KONA, ACCENT y CRETA*/}
        {modelo === "kona" && cedula && (
          <img src={`https://leadgenios.net/pixel.track?CID=473360&p=img&MerchantReferenceID=${cedula}`} width="1" height="1" border="0" alt="Pixel Kona" />
        )}
        {modelo === "nuevo-accent" && cedula && (
          <img src={`https://leadgenios.net/pixel.track?CID=473361&p=img&MerchantReferenceID=${cedula}`} width="1" height="1" border="0" alt="Pixel Accent" />
        )}
        {modelo === "nuevo-creta" && cedula && (
          <img src={`https://leadgenios.net/pixel.track?CID=473418&p=img&MerchantReferenceID=${cedula}`} width="1" height="1" border="0" alt="Pixel Creta" />
        )}
        <div className="hv-70">
          <div className="gracias-bg p-3 p-md-4">
            <Container className="bg-white">
              <Row>
                <Col md={12} className="p-3 px-md-5">
                  <Image
                    src={Gracias}
                    alt="gracias"
                    className="px-md-5"
                    fluid
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12} className="px-md-5">
                  <h2 className="titulo-gracias">
                    ¡GRACIAS, SU COTIZACIÓN <br /> SE CREÓ CORRECTAMENTE!
                  </h2>
                  <p className="texto-gracias px-md-5 mt-3">
                    Un asesor Hyundai se contactara con usted.
                  </p>
                </Col>
              </Row>
              <Row className="py-3">
                <Col md={12} className="pb-4 d-flex justify-content-center">
                  <Link to="/">
                    <Button
                      variant="primary"
                      type="submit"
                      className="btn-regresar"
                    >
                      Ir al inicio
                    </Button>
                  </Link>
                </Col>
              </Row>
            </Container>
            <Image
              src="https://pixel.loganmedia.mobi/pixel/c/24117"
              width="1"
              height="1"
            />
            <Image
              src=" https://pixel.loganmedia.mobi/pixel/c/20958"
              ancho="1"
              alto="1"
            />
          </div>
        </div>
      </Container>
    </Fragment>
  );
}
export default InfoGracias;